class CopyPasteUtil {
  public static copy(text: string): Promise<void> {
    if (!navigator.clipboard) {
      return this.fallbackCopyTextToClipboard(text);
    }
    return navigator.clipboard.writeText(text);
  }

  public static paste(): Promise<string> {
    return navigator.clipboard.readText();
  }

  private static fallbackCopyTextToClipboard(text: string) {
    const textArea = document.createElement('textarea');
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    const successful = document.execCommand('copy');
    const msg = successful ? 'successful' : 'unsuccessful';
    document.body.removeChild(textArea);
    if (msg == 'successful') return Promise.resolve();
    return Promise.reject();
  }
}

export default CopyPasteUtil;
